module.exports = __webpack_public_path__ + "img/HOME_LOGO_contrast.de4f9abf.png";